import { Route } from 'src/routes/Route'

export const ResetPasswordRoute = Route({
  path: '/reset-password',
})

export type ResetPasswordRoute = Route<typeof ResetPasswordRoute>
